import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Products from './components/Products';
import Advertising from './components/Advertising';
import Stores from './components/Stores';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import GalleryPage from './pages/GalleryPage';
import About from './pages/About';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Arial', sans-serif;
    overflow-x: hidden;
    width: 100%;
    background-color: #ffffff;
  }
`;

function App() {
  return (
    <Router>
      <GlobalStyle />
      <Routes>
        <Route path="/" element={
          <>
            <Navbar />
            <main style={{ width: '100%', minHeight: '100vh' }}>
              <Home />
              <Products />
              <Advertising />
              <Gallery />
              <Stores />
              <Contact />
            </main>
            <Footer />
          </>
        } />
        <Route path="/gallery" element={
          <>
            <Navbar />
            <GalleryPage />
            <Footer />
          </>
        } />
        <Route path="/about" element={
          <>
            <Navbar />
            <About />
            <Footer />
          </>
        } />
      </Routes>
    </Router>
  );
}

export default App